import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getConfig = () => api.get("/config").then((r) => r.data);
export const getAvailability = (date) =>
  api.get("/availability", { params: { date } }).then((r) => r.data);
export const createCheckout = (booking_id) =>
  api.post("/payments/checkout", { booking_id, origin_url: window.location.origin }).then((r) => r.data);
export const checkoutStatus = (session_id) => api.get(`/payments/status/${session_id}`).then((r) => r.data);
export const createBooking = (payload) =>
  api.post("/bookings", payload).then((r) => r.data);
export const lookupBooking = (email, reference) =>
  api.get("/bookings/lookup", { params: { email, reference } }).then((r) => r.data);
export const rescheduleBooking = (payload) =>
  api.post("/bookings/reschedule", payload).then((r) => r.data);
export const uploadFinishedPhoto = (payload) =>
  api.post("/bookings/finished-photo", payload).then((r) => r.data);
export const getShare = (reference) =>
  api.get(`/share/${reference}`).then((r) => r.data);

export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password }).then((r) => r.data);
export const adminMagic = (token) =>
  api.post("/admin/magic", { token }).then((r) => r.data);
export const adminRequestLink = (email) =>
  api.post("/admin/request-link", { email }).then((r) => r.data);
export const adminList = (token) =>
  api.get("/admin/bookings", auth(token)).then((r) => r.data);
export const adminApprove = (token, id) =>
  api.post(`/admin/bookings/${id}/approve`, {}, auth(token)).then((r) => r.data);
export const adminDeny = (token, id) =>
  api.post(`/admin/bookings/${id}/deny`, {}, auth(token)).then((r) => r.data);
export const adminUpdate = (token, id, patch) =>
  api.patch(`/admin/bookings/${id}`, patch, auth(token)).then((r) => r.data);
export const adminDelete = (token, id) =>
  api.delete(`/admin/bookings/${id}`, auth(token)).then((r) => r.data);
export const adminDenyRefund = (token, id) =>
  api.post(`/admin/bookings/${id}/deny_refund`, {}, auth(token)).then((r) => r.data);
export const adminRefund = (token, id, amount, reason) =>
  api.post(`/admin/bookings/${id}/refund`, { amount: amount || null, reason }, auth(token)).then((r) => r.data);
